const CONSTANTS = {
  API: '/v1.0/apikey',
  SMS: '/v1.0/sms',
}

export default CONSTANTS
